export default __webpack_public_path__ + "static/media/error.b7bbbbe9.svg";